(() => {
  const topicMessages = {
    'General question': 'Share a few details and we’ll connect you with the right specialist.',
    'Custom design': 'Tell our design team about your idea, preferred size and style.',
    'Existing order': 'Include your order number so customer care can check it quickly.',
    'Returns & warranty': 'Include your order number and describe the issue clearly.',
    'Business & press': 'Tell us about your company, audience or partnership idea.'
  };

  const initializeContactSection = (root) => {
    if (!root || root.dataset.snContactReady === 'true') return;

    const topicSelect = root.querySelector('[data-sn-topic-select]');
    const orderField = root.querySelector('[data-sn-order-field]');
    const orderInput = root.querySelector('[data-sn-order-input]');
    const phoneField = root.querySelector('[data-sn-phone-field]');
    const formContext = root.querySelector('[data-sn-form-context]');
    const routeCards = [...root.querySelectorAll('[data-sn-topic]')];
    const form = root.querySelector('.sn-contact-page__form');
    const successMessage = root.querySelector('[data-sn-contact-success]');

    if (!topicSelect || !orderField || !orderInput || !phoneField || !formContext || !form) return;

    const syncTopic = () => {
      const topic = topicSelect.value || 'General question';
      const needsOrder = topic === 'Existing order' || topic === 'Returns & warranty';

      orderField.hidden = !needsOrder;
      orderInput.required = needsOrder;
      phoneField.classList.toggle('sn-contact-page__field--wide', !needsOrder);
      formContext.textContent = topicMessages[topic] || topicMessages['General question'];

      routeCards.forEach((card) => {
        card.setAttribute('aria-pressed', String(card.dataset.snTopic === topic));
      });
    };

    routeCards.forEach((card) => {
      card.addEventListener('click', () => {
        topicSelect.value = card.dataset.snTopic;
        syncTopic();

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        form.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        window.setTimeout(() => topicSelect.focus({ preventScroll: true }), reducedMotion ? 0 : 450);
      });
    });

    topicSelect.addEventListener('change', syncTopic);
    syncTopic();

    if (successMessage) {
      successMessage.focus({ preventScroll: true });
    }

    root.dataset.snContactReady = 'true';
  };

  const initializeAllContactSections = (scope = document) => {
    scope.querySelectorAll('[data-sn-contact]').forEach(initializeContactSection);
  };

  initializeAllContactSections();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllContactSections(event.target);
  });
})();
